import {
  createContext,
  useContext,
  useSyncExternalStore,
  type ReactNode,
} from "react";

import {
  browserStorageSnapshot,
  subscribeBrowserStorage,
  type BrowserStorageAreaStatus,
} from "./browser-storage";
import {
  ProjectTurnOutboxProvider,
  type ProjectTurnOutboxStore,
} from "./project-turn-outbox";

const PrincipalContext = createContext<string | undefined>(undefined);

export function BrowserStateProvider({
  principalId,
  projectTurnOutboxStore,
  children,
}: {
  readonly principalId: string;
  /** Explicit dependency seam for deterministic browser-storage tests. */
  readonly projectTurnOutboxStore?: ProjectTurnOutboxStore;
  readonly children: ReactNode;
}) {
  return (
    <PrincipalContext.Provider value={principalId}>
      <ProjectTurnOutboxProvider
        key={principalId}
        principalId={principalId}
        store={projectTurnOutboxStore}
      >
        {children}
      </ProjectTurnOutboxProvider>
    </PrincipalContext.Provider>
  );
}

export function usePrincipalId(): string {
  const principalId = useContext(PrincipalContext);
  if (principalId === undefined) {
    throw new Error("usePrincipalId requires BrowserStateProvider");
  }
  return principalId;
}

function persistentBrowserStorageSnapshot(): BrowserStorageAreaStatus {
  return browserStorageSnapshot().persistent;
}

export function usePersistentBrowserStorageStatus(): BrowserStorageAreaStatus {
  return useSyncExternalStore(
    subscribeBrowserStorage,
    persistentBrowserStorageSnapshot,
    persistentBrowserStorageSnapshot,
  );
}
